export const SUPPORTED_LOCALES = ['ru'] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export type BackendLocale = 'ru' | 'en'

export type LocaleDirection = 'ltr' | 'rtl'

export interface LocaleMeta {
	label: string
	dir: LocaleDirection
}

export const localeMeta: Record<SupportedLocale, LocaleMeta> = {
	ru: {
		label: 'Русский',
		dir: 'ltr',
	},
}

export const DEFAULT_LOCALE: SupportedLocale = 'ru'
export const FALLBACK_LOCALE: SupportedLocale = 'ru'

export const I18N_NAMESPACES = ['common', 'main', 'profile'] as const

export type I18nNamespace = (typeof I18N_NAMESPACES)[number]
